import axios from 'axios'
import React, { useEffect } from 'react'
import { endpoint } from '../config'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { saveJWTTokenInCookie, saveProductIdInCookie, saveProductTypeInCookie, saveProspectAppIdInCookie } from '../utils'
import { useDispatch } from 'react-redux'
import { incrementFetchUserDtlTrg } from '../utils/reduxSlice/tempSlice'

export default function HashLogin({ setLoading }) {
	const [search] = useSearchParams()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	useEffect(() => {
		(async () => {
			const hash = search.get("hash");
			if (hash) {
				try {
					const { data } = await axios.get(`${endpoint}/api/seamless-login/${hash}`)
					saveProspectAppIdInCookie(data.data.credituid)
					saveJWTTokenInCookie(data.token);
					saveProductIdInCookie(1)
					saveProductTypeInCookie("Personal Loans")
					dispatch(incrementFetchUserDtlTrg());
					setLoading(true)
					navigate("/user/offers", {
						replace: true
					})
				} catch (error) {
					console.error("Error in API: ", error)
				} finally {
					setLoading(false)
				}
			}
		})()
	}, [])
	return null
}
